import { render, staticRenderFns } from "./CardDialogDetails.vue?vue&type=template&id=979f552a&scoped=true&"
import script from "./CardDialogDetails.vue?vue&type=script&lang=js&"
export * from "./CardDialogDetails.vue?vue&type=script&lang=js&"
import style0 from "./CardDialogDetails.vue?vue&type=style&index=0&id=979f552a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "979f552a",
  null
  
)

export default component.exports